import { render } from "./MultiPointCalibrationProfileCreate.vue?vue&type=template&id=0b15ad22"
import script from "./MultiPointCalibrationProfileCreate.vue?vue&type=script&lang=js"
export * from "./MultiPointCalibrationProfileCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__